import 'prop-types';
import 'react';
import clsx from 'clsx';
import { Button, Text } from 'reaxl';
import { ListingPaymentCTA } from 'reaxl-molecules';
import PersonalPayment from '../PersonalPayment/PersonalPayment.js';
import Payment from '../Payment/Payment.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function PaymentWrapper(_ref) {
  let {
    children,
    isCompact
  } = _ref;
  return /*#__PURE__*/jsxs(Text, {
    className: "margin-right-2",
    ...(!isCompact && {
      color: 'subdued'
    }),
    children: ["Est. ", children]
  });
}
function PaymentDisplay(_ref2) {
  let {
    onClick,
    payment,
    paymentOption,
    paymentsInfo,
    price,
    uiContext,
    vehicleCondition
  } = _ref2;
  const isCompact = uiContext === 'compact';
  return /*#__PURE__*/jsxs("div", {
    className: "display-flex flex-wrap align-items-baseline margin-left-3 text-size-200 text-normal",
    children: [!!payment && /*#__PURE__*/jsx(PaymentWrapper, {
      isCompact: isCompact,
      children: /*#__PURE__*/jsx(Payment, {
        payment: payment,
        uiContext: uiContext
      })
    }), !!paymentsInfo && /*#__PURE__*/jsx(PaymentWrapper, {
      isCompact: isCompact,
      children: /*#__PURE__*/jsx(PersonalPayment, {
        paymentsInfo: paymentsInfo,
        price: price,
        uiContext: uiContext,
        vehicleCondition: vehicleCondition
      })
    }), /*#__PURE__*/jsxs(Button, {
      bsStyle: "text",
      className: clsx('text-capitalize', {
        'link-decorated': isCompact
      }),
      onClick: onClick,
      children: ["See ", paymentOption, " Details"]
    })]
  });
}
function PaymentSnapshot(_ref3) {
  let {
    isWalletPaymentOptionEnabled = false,
    listing = {},
    onMyWalletClick = () => {},
    onPaymentCTAClick = () => {},
    paymentCardCTAProps = {},
    showPayment,
    showPaymentCTA,
    uiContext = 'withPayment'
  } = _ref3;
  const {
    id: listingId,
    pricingDetail = {},
    paymentServices: {
      digitalRetailingType = ''
    } = {},
    type
  } = listing;
  const {
    existingDeal = {},
    leasePaymentResponse = {},
    paymentEmphasis = false,
    paymentsInfo = {},
    pencilingPayment = {}
  } = paymentCardCTAProps;
  let {
    paymentOption = 'finance'
  } = paymentCardCTAProps;
  const {
    id: existingDealId
  } = existingDeal;
  const isExistingDeal = !!existingDealId;
  let {
    payment
  } = pencilingPayment;
  const {
    interestRate
  } = paymentsInfo || {};
  const {
    custom: customRate
  } = interestRate || {};
  const hasCustomRate = typeof customRate === 'number' && customRate >= 0;
  if (digitalRetailingType === 'psx' && paymentOption === 'lease') {
    paymentOption = 'finance';
  }
  const isLeaseEnabled = isWalletPaymentOptionEnabled && paymentOption === 'lease';
  const leasePaymentAvailable = isLeaseEnabled && Object.keys(leasePaymentResponse).length;
  if (isLeaseEnabled && leasePaymentAvailable) {
    payment = leasePaymentResponse.payment;
  }
  const hasPrice = !!pricingDetail.salePrice || !!pricingDetail.msrp;
  const showWalletPayments = showPayment && !!listingId && hasPrice;
  const enableEstimatedPaymentCTA = showWalletPayments && showPaymentCTA;
  const showWalletCta = enableEstimatedPaymentCTA && !paymentEmphasis && !isExistingDeal;
  const showLeasePayment = isLeaseEnabled && !leasePaymentAvailable;
  return showWalletCta ? /*#__PURE__*/jsx(ListingPaymentCTA, {
    onPaymentCTAClick: onPaymentCTAClick,
    className: clsx('display-flex align-items-baseline margin-left-3 text-size-200 text-normal', {
      'margin-top-1': uiContext !== 'compact',
      'link-decorated': uiContext === 'compact'
    })
  }) : !showLeasePayment && /*#__PURE__*/jsx(PaymentDisplay, {
    onClick: onMyWalletClick,
    payment: hasCustomRate ? undefined : payment,
    paymentOption: paymentOption,
    paymentsInfo: hasCustomRate ? paymentsInfo : undefined,
    price: pricingDetail.salePrice ?? pricingDetail.msrp ?? 0,
    uiContext: uiContext,
    vehicleCondition: type.toLowerCase() ?? 'used'
  });
}
export { PaymentSnapshot as default };
